export enum AvatarQueryKeys {
  Primary = 'avatars',
}
